import { Share } from '@capacitor/share'
import { Icon, Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react'

import { Button, Flex, Input, InputGroup, InputLeftElement, InputRightAddon } from '@chakra-ui/react'
import { useEffect } from 'react'
import { CopyLink, ExternalLink, Facebook, Instagram, Twitter } from '../icons/icons'

const CopyLinkModal = ({
  isOpen,
  onClose,
  onCopyLink,
  link,
  caption,
}: {
  isOpen: boolean
  onClose: () => void
  onCopyLink: () => void
  link: string
  caption: string
}) => {
  const canShare = async () => {
    const result = await Share.canShare()
    console.log(result)
  }

  useEffect(() => {
    canShare()
  }, [])

  const share = async () => {
    await Share.share({
      title: 'Check out this LVBL post',
      text: caption,
      url: import.meta.env.VITE_LOCAL_ENDPOINT + link,
      dialogTitle: 'Share with buddies',
    })
  }

  const shareToFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${import.meta.env.VITE_LOCAL_ENDPOINT + link}`
    window.open(facebookUrl, '_blank', 'width=550,height=420')
  }

  // const shareToInstagram = () => {
  //   const instagramUrl = `https://www.instagram.com/share?url=${import.meta.env.VITE_LOCAL_ENDPOINT + link}`
  //   window.open(instagramUrl, '_blank', 'width=550,height=420')
  // }

  const shareToTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(caption)}&url=${encodeURIComponent(
      import.meta.env.VITE_LOCAL_ENDPOINT + link
    )}`
    window.open(twitterUrl, '_blank', 'width=550,height=420')
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(import.meta.env.VITE_LOCAL_ENDPOINT + link)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent p="0" mx="10px">
        <ModalBody p="20px">
          <InputGroup cursor="pointer" onClick={onCopyLink}>
            <InputLeftElement>
              <ExternalLink color="#7E8B9A" />
            </InputLeftElement>
            <Input isDisabled variant="filled" value={import.meta.env.VITE_LOCAL_ENDPOINT + link} color="#7E8B9A" />
            <InputRightAddon bg="#171C22" color="white" gap="10px" onClick={handleCopy}>
              <CopyLink color="white" />
              Copy link
            </InputRightAddon>
          </InputGroup>
          <Flex gap="10px">
            <Button
              leftIcon={
                <Icon w="16px" h="16px" viewBox="0 0 16 16" color="#171C22">
                  <Instagram />
                </Icon>
              }
              onClick={() => {
                share()
                onClose()
              }}
              borderRadius="6px"
              fontSize="xs"
              variant="light"
              w="100%"
              mt="20px"
            >
              Instagram
            </Button>
            <Button
              leftIcon={
                <Icon w="16px" h="16px" viewBox="0 0 16 16" color="#171C22">
                  <Facebook />
                </Icon>
              }
              onClick={() => {
                shareToFacebook()
                onClose()
              }}
              borderRadius="6px"
              fontSize="xs"
              variant="light"
              w="100%"
              mt="20px"
            >
              Facebook
            </Button>
            <Button
              leftIcon={
                <Icon w="16px" h="16px" viewBox="0 0 16 16" color="#171C22">
                  <Twitter />
                </Icon>
              }
              onClick={() => {
                shareToTwitter()
                onClose()
              }}
              borderRadius="6px"
              fontSize="xs"
              variant="light"
              w="100%"
              mt="20px"
            >
              X
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default CopyLinkModal
